import React from 'react';

// Components
import DeliveryList from "./deliveryList";

// Constants
import { PAGE, PAGE_NAME } from '@utils/constants';

function DeliveryAll(props) {

    const BREADCRUMB = [
        {
            path: PAGE.STOCK_DELIVERY_PENDING,
            name: PAGE_NAME.STOCK_DELIVERY_PENDING
        }
    ];

    const availableDeliveryStatus = ['pending'];

    return (
        <DeliveryList {...props} breadcrumb={BREADCRUMB} availableDeliveryStatus={availableDeliveryStatus}/>
    );
}

export default DeliveryAll;